import { createRouter, RouterProvider } from "@tanstack/react-router";
import { MAIN_SCROLL_ID } from "@/shared/components/layouts/MainLayout";
import { routeTree } from "./routeTree";

/**
 * ⚠️ `scrollToTopSelectors` — `MainLayout` da `window` scroll bo'lmaydi,
 * scroll `#main-scroll` konteynerida. Router standart holatda faqat
 * `window` ni tepaga qaytaradi, ya'ni usiz yangi sahifa oldingisining
 * scroll o'rnida ochilardi. `"window"` ham qoladi — `AuthLayout` va
 * layout'siz sahifalar hali `window` bilan scroll bo'ladi.
 */
const router = createRouter({
	routeTree,
	scrollToTopSelectors: ["window", `#${MAIN_SCROLL_ID}`],
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

export function AppRouter() {
	return <RouterProvider router={router} />;
}
